import React, { useRef, useState } from "react";
import { react2Angular } from "~/Core/React2Angular";
import { useGetGlossaryTemplate, useUploadGlossary } from "~/Hooks/Api/Translations";
import { TS } from "~/Services/TS";

const Glossary = ({
    onImportResponse,
    onShowSpinner,
}: {
    onImportResponse: (isSuccess: boolean, errorMessage: string) => void;
    onShowSpinner: () => void;
}) => {
    const [file, setFile] = useState<File | null>(null);
    const [importButtonDisabled, setImportButtonDisabled] = useState<boolean>(false);
    const [isFileFormatValid, setIsFileFormatValid] = useState<boolean>(true);
    const fileUpload = React.createRef<HTMLInputElement>();

    const { refetch } = useGetGlossaryTemplate();
    const { mutateAsync } = useUploadGlossary();

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            var file = e.target.files[0];
            setFile(file);
            const isFileFormatValid = /\.csv$/.test(file.name);
            setImportButtonDisabled(!isFileFormatValid);
            setIsFileFormatValid(isFileFormatValid);
        }
    };
    const onUploadFileClick = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
        fileUpload.current?.click();
    };

    const handleImport = async () => {
        if (file) {
            setImportButtonDisabled(true);
            onShowSpinner();
            const formData = new FormData();
            formData.append("file", file);
            const result: any = await mutateAsync(formData);
            onImportResponse(result.isSuccess, result.errorMessage);
            setImportButtonDisabled(false);
        }
    };
    return (
        <>
            <div className="title-bar">
                <h1 className="title left">Glossary</h1>
                <span className="right">
                    <a className="button tertiary" href="/Excel/Sample_Glossary.csv" target="_blank">
                        {TS("Download Template")}
                    </a>
                    <button className="button" onClick={handleImport} disabled={!file || importButtonDisabled}>
                        {TS("Import")}
                    </button>
                </span>
            </div>
            <div className="grid-block vertical">
                <div className="glossary-container">
                    <form>
                        <label>
                            {TS("Upload file")} <span className="required">*</span>
                        </label>
                        <div className="grid-block">
                            <div className="medium-12 grid">
                                <div className="upload-btn-wrapper">
                                    <button className="button tertiary" onClick={onUploadFileClick}>
                                        <i className="fa-light fa-upload"></i> {TS("Upload a file")}
                                    </button>

                                    <input
                                        type="file"
                                        name="myfile"
                                        accept=".csv"
                                        ref={fileUpload}
                                        onChange={handleFileChange}
                                        onClick={(e: any) => {
                                            e.target.value = null;
                                        }}
                                    />
                                    <div className="upload-filename">
                                        <span className="">{file?.name ? file?.name : TS("No file chosen.")}</span>
                                    </div>
                                    {!isFileFormatValid && (
                                        <div className="error-messages">
                                            <span>
                                                <i className="fa-light fa-triangle-exclamation"></i>
                                                {TS("Please select a valid .csv file")}
                                            </span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

angular.module("insite-admin").component("glossary", react2Angular(Glossary, ["onImportResponse", "onShowSpinner"]));
